import * as Api from '@ViewModels';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Industry } from '../../../../extViewmodels';
import { CampaignType } from '../../../../models/AdminModels';
import { useEventLogging } from '../../../../models/Logging';
import { useAdminUserSession } from '../../../../models/hooks/adminStateHooks';
import { useErrorMessages, useFullscreenModal } from '../../../../models/hooks/appStateHooks';
import { TemplateCategoriesViewModel } from '../../../../viewmodels/AdminViewModels';
import { CategoriesByIndustry } from '../CategoriesByIndustry';

function _AdminIndustryTemplatesEmailTabContent({ industry }: { industry: Industry }) {
	const userSession = useAdminUserSession();
	const errorMessages = useErrorMessages();
	const fullscreenModal = useFullscreenModal();
	const { logApiError } = useEventLogging('EmailTabContent');
	const [categoriesVm] = React.useState(new TemplateCategoriesViewModel(userSession, industry, CampaignType.Email));
	React.useEffect(() => {
		categoriesVm.load()?.catch((error: Api.IOperationResultNoValue) => {
			logApiError(`LoadCampaignTemplatesEmailError`, error);

			errorMessages.pushApiError(error);
		});
	}, [categoriesVm, errorMessages, logApiError]);

	return (
		<CategoriesByIndustry
			industry={industry}
			categories={categoriesVm}
			campaignType={CampaignType.Email}
			onClickNewButton={() =>
				fullscreenModal.history.push({
					pathname: '/campaign-templates/email/edit',
				})
			}
		/>
	);
}

export const AdminIndustryTemplatesEmailTabContent = observer(_AdminIndustryTemplatesEmailTabContent);
